<template>
    <span style="position: relative">
      {{ columnTxt }}
      <el-tooltip class="item" effect="light" placement="top-start">
        <div slot="content"><span v-html="toolTipCon"></span></div>
        <i class="el-icon-question" style="position: absolute;top:-4px; right: -12px"></i>
      </el-tooltip>
    </span>
</template>

<script>
export default {
    props: {
        columnTxt: {
            type: String,
            required: true
        },
        toolTipCon: {
            type: String,
            required: true
        },
    }
}
</script>

<style>
</style>
